<template>
  <div class="input-container"
       ref="datepicker"
       :class="{
         'filled': isFilled,
         'focused': isFocused
       }">
    <span class="placeholder">{{ label }}</span>
    <input :type="type"
           @focus="onFocus"
           @blur="onBlur"
           :value="date !== null ? timeFormat(date) : ''">
    <b-timepicker class="form-datepicker"
                  size="is-small"
                  v-model="date"
                  hour-format="24"
                  v-show="visible"
                  inline>
    </b-timepicker>
  </div>
</template>

<script>
  import {filters} from '@/filters'

  export default {
    props: {
      value: {
        required: true
      },
      label: {
        type: String,
        required: false,
        default: ''
      },
      type: {
        type: String,
        required: false,
        default: 'text'
      },
      minDate: {
        type: Date,
        required: false,
        default: null
      }
    },
    data() {
      return {
        isFilled: false,
        isFocused: false,
        date: this.value,
        visible: false
      }
    },
    methods: {
      onFocus() {
        this.isFilled = true
        this.isFocused = true
        this.visible = true
      },
      onBlur() {
        this.isFocused = false
        if (this.value === null)
          this.isFilled = false
      },
      documentClick(e) {
        let el = this.$refs.datepicker
        let target = e.target
        if ((el !== target) && !el.contains(target)) {
          this.visible = false
        }
      },
      timeFormat: filters.timeFormat
    },
    watch: {
      date() {
        this.$emit('input', this.date)
        this.$nextTick(() => {
          this.onFocus()
          this.onBlur()
          this.visible = false
        })
      },
      value(date) {
        this.date = date
      }
    },
    mounted() {
      this.onFocus()
      this.onBlur()
      this.visible = false
    },
    created () {
      document.addEventListener('click', this.documentClick)
    },
    destroyed () {
      document.removeEventListener('click', this.documentClick)
    }
  }
</script>

<style lang="scss" scoped>
  .form-datepicker {
    position: absolute;
    top: 51px;
    z-index: 10;
    background: #fff;
  }

  .input-container {
    width: 100%;
    height: 52px;
    position: relative;

    .placeholder {
      position: absolute;
      top: 20px;
      color: #686868;
      z-index: 1;
      font-size: 14px;
      transition: all .2s ease;
    }

    &.filled .placeholder {
      top: 0;
      font-size: 13px;
      color: #afafaf;
    }

    &.focused .placeholder {
      color: #3498db;
    }

    input {
      position: relative;
      z-index: 1;
      background: transparent;
      margin: 18px 0 0 0;
      padding: 6px 0 8px 0;
      width: 100%;
      border: 0;
      border-bottom: 1px solid #d7dce9;
      font-size: 14px;
      transition: border-bottom-color .2s ease;
    }

    &.focused input {
      border-color: #3498db;
    }
  }
</style>